/* eslint-disable static-service/require-stories -- we have stories for the Markdown component */
import {StyleSheet} from "aphrodite";

import SimpleMarkdown from "@khanacademy/simple-markdown";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {
    HeadingLarge,
    HeadingMedium,
    HeadingSmall,
    Title,
} from "@khanacademy/wonder-blocks-typography";

import type {MarkdownRule} from "../types.ts";

// `simple-markdown` matcher for headings don't seem to do what we want. The
// following seems to work as expected – capturing the heading level (number of
// hash symbols) and heading text (non-newline characters). It accounts for
// optional spaces, trailing hash symbols, and newline characters.
// 1. ^: The caret symbol asserts the start of a line.
// 2.  *: Matches zero or more spaces.
// 3. (#{1,6}): This captures a group of one to six hash symbols (#), which
//              represent the heading level in Markdown (e.g., # Heading 1,
//              ## Heading 2, etc.).
// 4.  +: Matches one or more spaces.
// 5. ([^\n]+?): This captures a group of one or more characters that are not
//               newline characters (\n). The ? after + makes the quantifier
//               lazy, meaning it will match as few characters as possible.
// 6. (?: +#*)?: This is a non-capturing group (indicated by ?:). It matches
//               one or more spaces followed by zero or more hash symbols (#).
//               The entire group is optional (indicated by ?).
// 7. (?:\n *)*: Another non-capturing group that matches a newline character
//               followed by zero or more spaces. The * outside the group means
//               it can match this pattern zero or more times.
// 8. (?:\n|$): A non-capturing group that matches either a newline character
//              or the end of the input string (indicated by $).
const HEADING_R = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/;

export const headingRule: Readonly<MarkdownRule> = {
    ...SimpleMarkdown.defaultRules.heading,
    match: SimpleMarkdown.blockRegex(HEADING_R),
    react: (node, output, state) => {
        let Heading = null;
        switch (node.level) {
            case 1:
                // @ts-expect-error - TS2322 - Type 'typeof Title' is not assignable to type 'null'.
                Heading = Title;
                break;
            case 2:
                // @ts-expect-error - TS2322 - Type 'typeof HeadingLarge' is not assignable to type 'null'.
                Heading = HeadingLarge;
                break;
            case 3:
                // @ts-expect-error - TS2322 - Type 'typeof HeadingMedium' is not assignable to type 'null'.
                Heading = HeadingMedium;
                break;
            case 4:
                // @ts-expect-error - TS2322 - Type 'typeof HeadingSmall' is not assignable to type 'null'.
                Heading = HeadingSmall;
                break;
            default:
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'.
                Heading = "h" + node.level;
                break;
        }
        return (
            // @ts-expect-error - TS2604 - JSX element type 'Heading' does not have any construct or call signatures.
            <Heading key={state.key} style={styles.heading}>
                {output(node.content, state)}
            </Heading>
        );
    },
};

const styles = StyleSheet.create({
    heading: {
        marginBlockStart: 0,
        marginBlockEnd: spacing.medium_16,
        ":not(:first-child)": {
            marginBlockStart: spacing.large_24,
        },
    },
});
